import { AlertTriangle, RefreshCcw } from 'lucide-react'
import type { Document } from '@agentwiki/shared'
import { getDocumentKindInfo } from '../../lib/document-kind'
import { cn } from '../../lib/utils'

export function DocumentReaderStatusNotice({ doc }: { doc: Document }) {
  const kind = getDocumentKindInfo(doc).kind
  if (kind !== 'conflict' && kind !== 'stale') return null
  const conflict = kind === 'conflict'
  const Icon = conflict ? AlertTriangle : RefreshCcw
  const title = conflict ? 'Sync conflict' : 'Needs sync'
  const body = conflict
    ? 'This document no longer matches its last synced source snapshot.'
    : 'This document is behind its source provenance state.'

  return (
    <section className={cn('aw-knowledge-reader-notice', `is-${kind}`)} aria-label={title}>
      <Icon className="h-4 w-4" aria-hidden />
      <div>
        <strong>{title}</strong>
        <span>{body}</span>
      </div>
    </section>
  )
}
